import Image from "next/image";
import React, { useState } from "react";

const DoctorHowUSPathwayMobile = () => {
  const [activeTab, setActiveTab] = useState("india");

  return (
    <>
      <div className="mx-auto w-full xl:px-0 md:px-6 lg:!px-6 relative px-0 md:pt-[30px] md:pb-[60px] pt-8 bg-white bg-repeat bg-cover bg-[length:100% 100%]">
        <Image
          src="/cpa/visit/newVisit/bg-exams1.png"
          alt="Special Offer"
          className="absolute top-0 right-[69%] scale-x-[1]"
          width={506}
          height={530}
          loading="lazy"
        />
        <Image
          src="/cpa/visit/newVisit/bg-exams2.png"
          alt="Special Offer"
          className="absolute bottom-[-27px] right-[0%] scale-x-[1]"
          width={203}
          height={352}
          loading="lazy"
        />
        <div className="lg:container px-5 mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative md:block flex flex-col justify-center items-center">
          <h2 className="text-[28px] font-semibold leading-[1.1] text-center mb-0">
            How is the Miles MBBS-MD <br />
            U.S. Pathway <span className="visit_txt pr-[7px]">better?</span>
          </h2>

          <div className=" mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative md:block flex flex-col justify-center items-center">
            <div className="flex bg-[#3399FF40] rounded-[36px] mb-4 mt-4">
              <button
                className={`text-[10px] py-1 px-3 rounded-full ${
                  activeTab === "india"
                    ? "font-bold text-white bg-[#061A2F]"
                    : "text-[#04071E] font-normal leading-[1.2]"
                }`}
                onClick={() => setActiveTab("india")}
              >
                <span className="font-medium">MBBS & MD in India</span>
              </button>
              <button
                className={`text-[10px] py-1 px-3 rounded-full ${
                  activeTab === "abroad"
                    ? "font-semibold text-white bg-[#061A2F]"
                    : "text-[#04071E] font-normal leading-[1.2]"
                }`}
                onClick={() => setActiveTab("abroad")}
              >
                <span className="font-medium">MBBS Abroad</span>
              </button>
              <button
                className={`text-[10px] py-1 px-3 rounded-full ${
                  activeTab === "caribbean"
                    ? "font-semibold text-white bg-[#061A2F]"
                    : "text-[#04071E] font-normal leading-[1.2]"
                }`}
                onClick={() => setActiveTab("caribbean")}
              >
                <span className="font-medium">Caribbean MBBS-MD Programs</span>
              </button>
            </div>
            {activeTab === "india" && (
              <div className="w-full mx-auto">
                <div className="w-[100%] mx-auto mb-4">
                  <div className=" overflow-hidden rounded-[10px] border-[1px] border-[#C0DDFD] shadow-md">
                    <table className="w-full">
                      <thead className="w-full text-black">
                        <tr className="text-[#fff] bg-[linear-gradient(90deg,_#0C1F33_0%,_#0448AA_100%)] border-b border-[#C0DDFD]">
                          <th className="md:w-[42%] w-[30%] border-b border-[#C0DDFD]"></th>
                          <th className="md:w-[28%] border-b border-[#C0DDFD] text-[14px] leading-[1.2] text-center">
                            <span className="md:px-5 px-2 py-3 block font-bold">
                              Miles MBBS-MD U.S. Pathway
                            </span>
                          </th>
                          <th className="md:w-[28%] w-[40%] border-b font-normal border-[#C0DDFD] text-[14px] leading-[1.2]">
                            <span>MBBS & MD in India</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] block font-semibold">
                              NEET UG
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] block font-semibold">
                              Only NEET qualifying score
                            </span>
                          </td>
                          <td>
                            <span className="py-3 px-2 text-[11px] block">
                              Need to secure top rank in NEET UG
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                              NEET PG/ NExT
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block">
                              USMLE in lieu of NEET PG / NExT
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              Need to secure top rank in NEET PG / NExT
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                              Degree
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              BS + MD + License to practice medicine in USA &
                              India
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              MBBS + MD + License to practice medicine in India
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                              Location
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              3 years in the Caribbean + 6 years in USA
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              9 years in India
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                              Tuition
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              Annual tuition of ~₹20 Lakhs per year for only 5
                              years for UG +PG [no tuition during Residency].
                              Recoup the tuition with Residency Stipends of ~₹50
                              lakhs per year for next 4 years [funding by U.S.
                              government)
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              Annual tuition of ~₹20 Lakhs per year for 9 years
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#fff] bg-[linear-gradient(90deg,_#0C1F33_0%,_#0448AA_100%)] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                              Salary after MD
                            </span>
                          </td>
                          <td className=" ">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-bold block leading-[1.3] text-center">
                              ₹2 Crore+ p.a. ($250K+)
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3] text-center">
                              ₹30 Lakhs p.a.
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "abroad" && (
              <div className="w-full mx-auto">
                <div className="w-[100%] mx-auto mb-4">
                  <div className=" overflow-hidden rounded-[10px] border-[1px] border-[#C0DDFD] shadow-md">
                    <table className="w-full">
                      <thead className="w-full text-black">
                        <tr className="text-[#fff] bg-[linear-gradient(90deg,_#0C1F33_0%,_#0448AA_100%)] border-b border-[#C0DDFD]">
                          <th className="md:w-[42%] w-[30%] border-b border-[#C0DDFD]"></th>
                          <th className="md:w-[28%] border-b border-[#C0DDFD] text-[14px] leading-[1.2] text-center">
                            <span className="px-2 py-3 block font-semibold">
                              Miles MBBS-MD U.S. Pathway
                            </span>
                          </th>
                          <th className="md:w-[28%] w-[40%] border-b font-normal border-[#C0DDFD] text-[14px] leading-[1.2] px-2">
                            <span>
                              MBBS Abroad (Russia/Central Asia/Eastern Europe
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] block font-semibold">
                              Degree & Duration
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] block font-semibold">
                              MD from America (Integrated UG+PG) in 5 years
                            </span>
                          </td>
                          <td>
                            <span className="py-3 px-2 text-[11px] block">
                              MBBS from Central Asia/Eastern Europe in 6 years,
                              PG pathway uncertain
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                              Program Structure
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block">
                              3 years in Caribbean +2 years of clinical
                              rotations in U.S. hospitals
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              Entire duration in Central Asia / Eastern Europe;
                              no U.S. clinical exposure
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                              Learning Environment
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              Taught by U.S. faculty; fully in English
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              Local/Indian faculty; instruction in Russian,
                              Kazakh, Kyrgyz, Uzbek Georgian, Serbian, Mandarin,
                              etc.,
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                              Peer Group
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              80 % + U.S. students in class
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              MBBS Abroad students from India mixed with local
                              students
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                              Clinical Exposure
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              Hands-on U.S. hospital training with direct
                              patient interaction
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              Limited exposure in local hospitals; language
                              barriers hinder learning
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                          <td className=" ">
                            <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                              Tuition
                            </span>
                          </td>
                          <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                            <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                              Annual tuition of ~₹20 Lakhs per year for only 5
                              years for UG+PG [no tuition during Residency].
                              Recoup the tuition with Residency Stipends of ~₹50
                              Lakhs per year for next 4 years [funding by U.S.
                              government]
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                              Annual tuition of less than ~₹10 lakhs per year
                              for 6 years - but covers only UG (MBBS); PG
                              Pathway uncertain
                            </span>
                          </td>
                        </tr>
                        <tr className="text-[#fff] bg-[linear-gradient(90deg,_#0C1F33_0%,_#0448AA_100%)] border-b border-[#C0DDFD]">
                          <td>
                            <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                              Career & Salary
                            </span>
                          </td>
                          <td>
                            <span className="py-2 md:px-8 px-2 text-[11px] font-bold block leading-[1.3]">
                              Become a licensed doctor in the USA & India; ₹2
                              Crore+ salary potential
                            </span>
                          </td>
                          <td>
                            <span className="py-3 md:px-8 px-2 text-[11px] font-normal block leading-[1.3]">
                              NIL unless you clear the Indian PG pathway (FMGE &
                              NEET PG) & become a doctor in India Note: FIMGE
                              pass rates are less than 20%
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "caribbean" && (
              <div className="w-[100%] mx-auto mb-4">
                <div className=" overflow-hidden rounded-[10px] border-[1px] border-[#C0DDFD] shadow-md">
                  <table className="w-full">
                    <thead className="w-full text-black">
                      <tr className="text-[#fff] bg-[linear-gradient(90deg,_#0C1F33_0%,_#0448AA_100%)] border-b border-[#C0DDFD]">
                        <th className="md:w-[42%] w-[30%] border-b border-[#C0DDFD]"></th>
                        <th className="md:w-[28%] border-b border-[#C0DDFD] text-[14px] leading-[1.2] text-center">
                          <span className="md:px-5 px-2 py-3 block font-bold">
                            Miles MBBS-MD U.S. Pathway
                          </span>
                        </th>
                        <th className="md:w-[28%] w-[40%] border-b font-normal border-[#C0DDFD] text-[14px] leading-[1.2] text-center px-2 py-3">
                          <span>Caribbean MBBS-MD Programs</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                        <td className=" ">
                          <span className="py-3 md:px-8 px-2 text-[12px] block font-semibold">
                            Schools
                          </span>
                        </td>
                        <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                          <span className="py-2 md:px-8 px-2 text-[11px] block font-semibold">
                            Top 10 Universities • SGU - Rank #1 • SJSM
                          </span>
                        </td>
                        <td>
                          <span className="py-3 md:px-8 px-2 text-[11px] block">
                            Texila American University, Lincoln American
                            University, American University of Barbados, others
                          </span>
                        </td>
                      </tr>
                      <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                        <td className=" ">
                          <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                            Year of Establishment
                          </span>
                        </td>
                        <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                          <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block">
                            SGU - 1976; SJSM: 1999
                          </span>
                        </td>
                        <td>
                          <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                            Established after 2010
                          </span>
                        </td>
                      </tr>
                      <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                        <td className=" ">
                          <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                            Success Score (U.S. Medical Residency)
                          </span>
                        </td>
                        <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                          <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                            1,000+ students match into U.S. Medical Residency
                            every year [20,000+ till-date]
                          </span>
                        </td>
                        <td>
                          <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                            Almost 0 - very very few students have matched into
                            U.S. Medical Residency
                          </span>
                        </td>
                      </tr>
                      <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                        <td className=" ">
                          <span className="py-3 md:px-8 px-2 text-[12px] font-semibold block">
                            Peer Group (U.S. Students)
                          </span>
                        </td>
                        <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                          <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                            80%+ U.S. students in a class (1000+ U.S. students
                            join these schools each year)
                          </span>
                        </td>
                        <td>
                          <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                            Almost 0 - U.S. students do NOT join these
                            universities - peer group is mainly Indian / African
                            / Carribean
                          </span>
                        </td>
                      </tr>

                      <tr className="text-[#0C2036] border-b border-[#C0DDFD]">
                        <td className=" ">
                          <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                            Tuition
                          </span>
                        </td>
                        <td className="border-[1px] border-[#C0DDFD] bg-[#E3F0FF]">
                          <span className="py-2 md:px-8 px-2 text-[11px] font-semibold block leading-[1.3]">
                            Annual tuition of ~₹20 lakhs per year for 5 years.
                            Recoup the tuition with Residency Stipends o f ~₹50
                            lakhs per year for next 4 years [funding by U.S.
                            government]
                          </span>
                        </td>
                        <td>
                          <span className="py-3 md:px-8 px-2 text-[11px] block leading-[1.3]">
                            Annual tuition of -210 lakhs per year for 5 years.
                            Little or no track record of Residency / Future
                            pathway uncertain
                          </span>
                        </td>
                      </tr>
                      <tr className="text-[#fff] bg-[linear-gradient(90deg,_#0C1F33_0%,_#0448AA_100%)] border-b border-[#C0DDFD]">
                        <td className=" ">
                          <span className="py-3 md:px-8 px-2 block text-[12px] font-semibold">
                            Career & Salary
                          </span>
                        </td>
                        <td>
                          <span className="py-2 md:px-8 px-2 text-[11px] font-bold block leading-[1.3] text-center">
                            Become a licensed doctor in the USA; ₹2 Crore+
                            salary potential
                          </span>
                        </td>
                        <td>
                          <span className="py-3 md:px-8 px-2 text-[11px] font-normal block leading-[1.3] text-center">
                            Little or no track record of Residency - a
                            requirement to become a licensed U.S. doctor
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorHowUSPathwayMobile;
